import { useLingui } from "@lingui/react/macro";

import { Button } from "@/shared/ui/button";
import { Skeleton } from "@/shared/ui/skeleton";

import { useDrillSeries } from "../../api/useDrillSeries";
import { useDrillsOverview } from "../../api/useDrillsOverview";
import { CaughtUp } from "./CaughtUp";
import { NoAnalyses } from "./NoAnalyses";
import { SeriesRun } from "./SeriesRun";

// Экран «Тренировка» по макету design/prototype/DrillRelease.dc.html: серия из пяти задач,
// итог серии, «Разборов нет» и «На сегодня всё».
export const DrillPage = () => {
  const { t } = useLingui();
  const overview = useDrillsOverview();
  const series = useDrillSeries();
  let body;
  if (overview.isError || series.isError) {
    body = (
      <div role="alert" className="flex flex-col items-start gap-3">
        <p className="text-muted">{t`Could not load the training. Try again.`}</p>
        <Button
          variant="outline"
          onClick={() => {
            void overview.refetch();
            void series.refetch();
          }}
        >
          {t`Try again`}
        </Button>
      </div>
    );
  } else if (overview.data === undefined || series.data === undefined) {
    body = (
      <div aria-busy="true" className="flex flex-col gap-4">
        <Skeleton className="h-10 w-64" />
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-48 w-full" />
      </div>
    );
  } else if (series.data.series === null) {
    body = overview.data.has_analyses ? <CaughtUp overview={overview.data} /> : <NoAnalyses />;
  } else {
    body = (
      <SeriesRun key={series.data.series.id} series={series.data.series} overview={overview.data} />
    );
  }
  return (
    <main
      data-page="drills"
      className="mx-auto flex w-full max-w-[1000px] flex-col gap-5 px-4 pt-7 pb-14 sm:px-6"
    >
      {body}
    </main>
  );
};
